import React from 'react';
import { Navigate } from 'react-router-dom';
import { 
  Box, 
  CssBaseline
} from '@mui/material';
import { useAuth } from '../../contexts/AuthContext';
import { UserRole } from '../../types/user';

interface LayoutProps {
  children: React.ReactNode;
  requiredRoles?: UserRole[];
}

const isValidUserRole = (role: string | UserRole): boolean => {
  return Object.values(UserRole).includes(role as UserRole);
};

const convertToUserRole = (role: string | UserRole): UserRole | undefined => {
  return isValidUserRole(role) ? role as UserRole : undefined;
};

const Layout: React.FC<LayoutProps> = ({ children, requiredRoles }) => {
  const { user, isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (requiredRoles && requiredRoles.length > 0) {
    const userRole = user?.role ? convertToUserRole(user.role) : undefined;
    if (!userRole || !requiredRoles.includes(userRole)) {
      return <Navigate to="/unauthorized" replace />;
    }
  }

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          width: '100%',
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default Layout;
